/* eslint-disable react/no-array-index-key */
import { navigate } from 'gatsby'
import React from 'react'

import { languageSelector } from './LanguageSwitcher.module.css'

const LanguageSwitcher = ({ altLanguages, currentLang, extraClassName }) => {
  const currentLangOption = (
    <option value={currentLang}>{currentLang.slice(0, 2).toUpperCase()}</option>
  )
  const alternateLangsOptions = altLanguages.map((lang, index) => {
    if (!lang) return null
    return (
      <option key={index} value={lang.url}>
        {lang.lang.slice(0, 2).toUpperCase()}
      </option>
    )
  })
  const handleLangChange = (event) => {
    navigate(event.target.value)
  }
  return (
    <select
      aria-label="language"
      className={`${languageSelector} ${extraClassName}`}
      onChange={handleLangChange}
      value={currentLang}
    >
      {currentLangOption}
      {alternateLangsOptions}
    </select>
  )
}

export default LanguageSwitcher
